export const useFirstItem = <T>(array: MaybeRef<T[] | undefined>) => {
	const firstItem = computed(() => {
		const unrefArray = unref(array);
		return Array.isArray(unrefArray) ? unrefArray[0] : undefined;
	});
	return firstItem;
};
